// front-end/src/components/block-system/block-configs/block-types/vacancy-block.js

export function createVacancyBlock(block, parent) {
    const blockName = block.data_block_name;
    const isMobile = window.innerWidth <= 768;

    // Создаем основной контейнер вакансии
    const vacancyItem = document.createElement('div');
    vacancyItem.className = 'vacancy-slide container-fluid';
    vacancyItem.setAttribute('data-block-name', blockName);

    if (block.id && block.id !== 'undefined') {
        vacancyItem.setAttribute('data-block-id', block.id);
    }

    if (block.order !== undefined && block.order !== null) {
        vacancyItem.setAttribute('data-order', String(block.order));
    } else {
        vacancyItem.setAttribute('data-order', '0');
    }

    vacancyItem.style.position = 'relative';

    // ВАЖНО: Добавляем атрибуты для работы с vacancy системой
    if (block.vacancy_id) {
        vacancyItem.setAttribute('data-vacancy-id', block.vacancy_id);
    }
    if (block.vacancy_status) {
        vacancyItem.setAttribute('data-vacancy-status', block.vacancy_status);
    }
    if (block.vacancy_slug) {
        vacancyItem.setAttribute('data-vacancy-slug', block.vacancy_slug);
    }

    // Определяем активность ссылки на основе статуса
    const isActiveLink = block.vacancy_status === 'published' || block.id;
    const vacancyHref = isActiveLink && block.vacancy_slug ? `/vacancy/${block.vacancy_slug}` : '#';

    // ВАЖНО: Проверяем авторизацию для показа статуса
    const {isAuthenticated} = require('../../../auth');
    const showStatusIndicator = isAuthenticated() && block.vacancy_status;

    // Разная разметка для мобильных и десктопа
    if (isMobile) {
        // language=HTML
        vacancyItem.innerHTML = `
            <div class="accordion-main vacancy-accordion">
                <div class="row">
                    <div class="col-12">
                        <div class="vacancy-header d-flex justify-content-between align-items-center">
                            <h4 class="vacancy-name" data-content="${blockName}-full-title" data-global="true"></h4>
                            <button class="open-accordion"
                                    style="background: none; border: none; cursor: pointer; padding: 0;">
                                <img src="/images/accordion-closed.svg" alt="open"
                                     style="width: 24px; height: 24px;">
                            </button>
                            <button class="close-accordion"
                                    style="background: none; border: none; cursor: pointer; display: none; padding: 0;">
                                <img src="/images/opened-accordion.svg" alt="close"
                                     style="width: 24px; height: 24px;">
                            </button>
                        </div>
                    </div>
                </div>
                <div class="accordion-inner" style="max-height: 0; overflow: hidden; transition: max-height 0.3s ease;">
                    <div class="row mt-3">
                        <div class="col-12">
                            <p class="vacancy-block-description " data-content="${blockName}-description" data-type="textarea" data-global="true"></p>

                            <div class="all-tags mb-3">
                                <div class="vacancy-tags-container">
                                    <div class="vacancy-tag">
                                        <p data-content="${blockName}-experience" data-type="textarea"
                                           data-global="true"></p>
                                    </div>
                                    <div class="vacancy-tag">
                                        <p data-content="${blockName}-location" data-global="true"></p>
                                    </div>
                                    <div class="vacancy-tag">
                                        <p data-content="${blockName}-payment" data-global="true"></p>
                                    </div>
                                    <div class="vacancy-tag">
                                        <p data-content="${blockName}-schedule" data-global="true"></p>
                                    </div>
                                </div>
                            </div>


                            <a href="${vacancyHref}"
                               class="news-link-to-feed-container ${isActiveLink ? 'active' : 'inactive'} mt-3">
                                Дізнатися більше
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            ${showStatusIndicator ? `
            <div class="vacancy-status-indicator status-${block.vacancy_status}">
                <span class="status-text">${block.vacancy_status.toUpperCase()}</span>
            </div>
            ` : ''}
        `;
    } else {
        // Десктопная версия (оригинальная)
        vacancyItem.innerHTML = `
            <div class="row">
                <div class="col-lg-6 col-md-6 d-flex flex-column justify-content-between p-0">
                    <p class="publication-date" data-content="${blockName}-date" data-global="true" data-type="date"></p>
                    <div class="all-tags">
                        <div class="vacancy-tags-container d-flex flex-row justify-content-between">
                            <div class="vacancy-tag">
                                <p data-content="${blockName}-location" data-global="true"></p>
                            </div>
                            <div class="vacancy-tag">
                                <p data-content="${blockName}-payment" data-global="true"></p>
                            </div>
                            <div class="vacancy-tag">
                                <p data-content="${blockName}-schedule" data-global="true"></p>
                            </div>
                        </div>
                        <div class="vacancy-tags-container justify-content-center">
                            <div class="vacancy-tag">
                                <p data-content="${blockName}-experience" data-type="textarea" data-global="true"></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 d-flex flex-row justify-content-between">
                    <div class="case-inner-text">
                        <h4 class="vacancy-name" data-content="${blockName}-full-title" data-global="true"></h4>
                        <p data-content="${blockName}-description" data-type="textarea" data-global="true"></p>
                        <a href="${vacancyHref}" class="news-link-to-feed-container ${isActiveLink ? 'active' : 'inactive'}">
                            Дізнатися більше
                        </a>
                    </div>
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="5" cy="5" r="5" fill="#0090B8"/>
                    </svg>
                </div>
            </div>
            ${showStatusIndicator ? `
            <div class="vacancy-status-indicator status-${block.vacancy_status}">
                <span class="status-text">${block.vacancy_status.toUpperCase()}</span>
            </div>
            ` : ''}
        `;
    }

    parent.appendChild(vacancyItem);

    // Инициализируем аккордеон на мобильных
    if (isMobile) {
        setTimeout(() => initializeVacancyAccordion(vacancyItem), 100);
    }

    return vacancyItem;
}

// Функция инициализации аккордеона для вакансии
function initializeVacancyAccordion(vacancyItem) {
    const accordion = vacancyItem.querySelector('.vacancy-accordion');
    if (!accordion) return;

    const openBtn = accordion.querySelector('.open-accordion');
    const closeBtn = accordion.querySelector('.close-accordion');
    const accordionInner = accordion.querySelector('.accordion-inner');
    const header = accordion.querySelector('.vacancy-header');

    if (openBtn && closeBtn && accordionInner && header) {
        // Делаем хедер кликабельным
        header.style.cursor = 'pointer';

        // Обработчик на весь хедер
        header.addEventListener('click', (e) => {
            if (!e.target.closest('.open-accordion') && !e.target.closest('.close-accordion')) {
                const isOpen = accordionInner.classList.contains('open');
                toggleVacancyAccordion(accordion, !isOpen);
            }
        });

        // Обработчики на кнопки
        openBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            toggleVacancyAccordion(accordion, true);
        });

        closeBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            toggleVacancyAccordion(accordion, false);
        });
    }
}

// Функция переключения аккордеона
function toggleVacancyAccordion(accordion, shouldOpen) {
    const accordionInner = accordion.querySelector('.accordion-inner');
    const openBtn = accordion.querySelector('.open-accordion');
    const closeBtn = accordion.querySelector('.close-accordion');
    const headerTextElements = accordion.querySelectorAll('.vacancy-header h4, .vacancy-header p');
    const innerTextElements = accordionInner.querySelectorAll('h4, p, a'); // ФИКС: добавил 'a'
    const vacancyBlock = accordion.closest('.vacancy-slide');

    if (shouldOpen) {
        // Открываем
        accordionInner.style.display = 'block';
        setTimeout(() => {
            const scrollHeight = accordionInner.scrollHeight;
            accordionInner.style.maxHeight = scrollHeight + 'px';
        }, 10);

        accordionInner.classList.add('open');
        accordion.classList.add('accordion-container-open');

        // Добавляем градиентный фон
        vacancyBlock.style.background = 'linear-gradient(143deg, #19b5e1 0%, #0090b8 100%)';

        // Меняем цвет текста на белый
        headerTextElements.forEach(el => {
            el.classList.add('text-color-white');
            el.style.setProperty('color', 'white', 'important');
        });

        innerTextElements.forEach(el => {
            // Проверяем, не находится ли элемент внутри .vacancy-tag
            if (!el.closest('.vacancy-tag')) {
                el.classList.add('text-color-white');
                el.style.setProperty('color', 'white', 'important');
            }
        });

        openBtn.style.display = 'none';
        closeBtn.style.display = 'inline-block';
    } else {
        // Закрываем
        accordionInner.style.maxHeight = '0';
        accordionInner.classList.remove('open');
        accordion.classList.remove('accordion-container-open');

        // Убираем градиентный фон
        vacancyBlock.style.removeProperty('background');

        // Возвращаем исходный цвет текста
        headerTextElements.forEach(el => {
            el.classList.remove('text-color-white');
            el.style.removeProperty('color');
        });

        innerTextElements.forEach(el => {
            // Возвращаем исходный цвет текста, но не трогаем элементы в .vacancy-tag
            if (!el.closest('.vacancy-tag')) {
                el.classList.remove('text-color-white');
                el.style.removeProperty('color');
            }
        });

        setTimeout(() => {
            openBtn.style.display = 'inline-block';
            closeBtn.style.display = 'none';
            accordionInner.style.display = 'none';
        }, 300);
    }
}

// Глобальный обработчик ресайза для вакансий
let vacancyResizeTimeout;
let previousIsMobile = window.innerWidth <= 768;

function setupVacancyResizeHandler() {
    // Проверяем, не установлен ли уже обработчик
    if (window.vacancyResizeHandlerInitialized) return;
    window.vacancyResizeHandlerInitialized = true;

    window.addEventListener('resize', () => {
        clearTimeout(vacancyResizeTimeout);
        vacancyResizeTimeout = setTimeout(() => {
            const currentIsMobile = window.innerWidth <= 768;

            // Если режим изменился
            if (previousIsMobile !== currentIsMobile) {
                console.log('[VacancyBlock] Режим изменился, перестраиваем блоки');
                previousIsMobile = currentIsMobile;
                rebuildAllVacancyBlocks(currentIsMobile);
            }
        }, 150);
    });
}

// Функция перестройки всех блоков вакансий
function rebuildAllVacancyBlocks(isMobile) {
    // Находим все блоки вакансий
    const vacancyBlocks = document.querySelectorAll('.vacancy-slide[data-block-name^="vacancy-block-"]');
    console.log(`[VacancyBlock] Найдено ${vacancyBlocks.length} блоков для перестройки`);

    vacancyBlocks.forEach(block => {
        const blockName = block.getAttribute('data-block-name');
        const blockId = block.getAttribute('data-block-id');
        const order = block.getAttribute('data-order');
        const vacancyId = block.getAttribute('data-vacancy-id');
        const vacancyStatus = block.getAttribute('data-vacancy-status');
        const vacancySlug = block.getAttribute('data-vacancy-slug');

        // Сохраняем контент
        const contentData = {};
        const contentElements = block.querySelectorAll('[data-content]');
        contentElements.forEach(el => {
            const tagId = el.getAttribute('data-content');
            contentData[tagId] = el.textContent || el.innerText || '';
        });

        // Создаем объект блока
        const blockData = {
            data_block_name: blockName,
            id: blockId,
            order: parseInt(order) || 0,
            vacancy_id: vacancyId,
            vacancy_status: vacancyStatus,
            vacancy_slug: vacancySlug
        };

        // Пересоздаем блок
        const parent = block.parentElement;
        const newBlock = createVacancyBlock(blockData, document.createElement('div'));

        // Восстанавливаем контент
        Object.keys(contentData).forEach(tagId => {
            const element = newBlock.querySelector(`[data-content="${tagId}"]`);
            if (element) {
                element.textContent = contentData[tagId];
            }
        });

        // Заменяем старый блок новым
        parent.replaceChild(newBlock, block);

        // Если нужны кнопки редактирования/удаления - добавьте их тут
        const {isAuthenticated} = require('../../../auth');
        if (isAuthenticated()) {
            // Тут можно добавить контролы для редактирования
            // addDeleteButton(newBlock, blockId);
            // setupEditButtons(newBlock);
        }
    });

    console.log('[VacancyBlock] Перестройка завершена');
}

// Инициализируем обработчик при загрузке
if (typeof window !== 'undefined') {
    setupVacancyResizeHandler();
}

// Функция для извлечения номера из имени блока
function getBlockNumber(blockName) {
    const match = blockName.match(/-(\d+)$/);
    return match ? match[1] : '1';
}

export const vacancyBlockProps = {
    name: 'vacancy-block',
    title: 'Блок вакансії',
    description: 'Блок для відображення вакансії',
    allowedParents: ['vacancies-section'],
    contentFields: [
        {name: 'date', type: 'date', label: 'Дата публікації'},
        {name: 'title', type: 'text', label: 'Назва вакансії'},
        {name: 'description', type: 'textarea', label: 'Короткий опис'},
        {name: 'location', type: 'text', label: 'Локація'},
        {name: 'payment', type: 'text', label: 'Розрахунок'},
        {name: 'schedule', type: 'text', label: 'Графік'},
        {name: 'experience', type: 'textarea', label: 'Досвід'}
    ],
    renderPreview: (data) => {
        return `
            <div class="block-preview vacancy-block-preview">
                <div class="row">
                    <div class="col-6">
                        <p class="date">${data.date || 'Дата'}</p>
                        <div class="tags">
                            <span class="tag">${data.location || 'Локація'}</span>
                            <span class="tag">${data.schedule || 'Графік'}</span>
                        </div>
                    </div>
                    <div class="col-6">
                        <h5>${data.title || 'Назва вакансії'}</h5>
                        <p>${data.description || 'Опис вакансії...'}</p>
                    </div>
                </div>
            </div>
        `;
    }
};